import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "access-filter-dropdown" }
const _hoisted_2 = { class: "access-filter-dropdown__header" }
const _hoisted_3 = { class: "access-filter-dropdown__search" }
const _hoisted_4 = {
  key: 0,
  class: "access-filter-dropdown__controls"
}
const _hoisted_5 = { class: "access-filter-dropdown__controls-left" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "access-filter-dropdown__state"
}
const _hoisted_8 = {
  key: 1,
  class: "access-filter-dropdown__options"
}

import { computed, onMounted, ref } from 'vue';
import { AccessApi } from '@/ api/AccessApi';
import type { WorkersAndAccessGroupsInSettingsGiver } from '@/models/interfaces/access/entity-rules';
import type { SelectGroup, SelectOption } from '@/components/ui-kit/select/AppSelect.vue';
import UserGroupDropdownContent from '@/components/permitions/UserGroupDropdownContent.vue';
import AppInput from '@/components/ui-kit/input/AppInput.vue';
import AppCheckbox from '@/components/ui-kit/checkbox/AppCheckbox.vue';

interface EntityFilter {
  Entity: { Id: number; Name: string };
  Roles: any[];
  Positive: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccessFilterDropdownContent',
  props: {
    modelValue: {},
    singleMode: { type: Boolean }
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const loading = ref(false);
const search = ref('');
const showOnlySelected = ref(false);
const source = ref<WorkersAndAccessGroupsInSettingsGiver | null>(null);

const items = computed<SelectOption[]>(() => {
  const result: SelectOption[] = [];
  const withoutDepartment: SelectOption[] = [];

  source.value?.Holders?.forEach((holder, index) => {
    if (holder.Departament) {
      result.push({
        id: index + 999999,
        label: holder.Departament.Name,
        type: 'group',
        selectable: false,
        children: (holder.Departament.Workers ?? []).map((worker) => ({
          id: worker.GroupId,
          label: worker.Name,
          type: 'item',
        })),
      });
    } else if (holder.IsWorker && holder.Worker) {
      withoutDepartment.push({
        id: holder.Worker.GroupId,
        label: holder.Worker.Name,
        type: 'item',
      });
    }
  });

  for (const group of source.value?.Groups ?? []) {
    if (!group.IsPersonal) {
      result.push({
        id: group.Id,
        label: group.Name,
        type: 'group',
        selectable: true,
        children: [],
      });
    }
  }

  if (withoutDepartment.length) {
    result.push({
      id: -1,
      label: 'Без отдела',
      type: 'group',
      selectable: false,
      children: withoutDepartment,
    });
  }
  return result;
});

const filteredItems = computed<SelectOption[]>(() => {
  const term = search.value.trim().toLocaleLowerCase();
  return items.value.flatMap((item) => {
    const labelMatches = item.label.toLocaleLowerCase().includes(term);
    if (!('children' in item) || !item.children?.length) {
      const isSelected = selectedIds.value.includes(item.id);
      return (!showOnlySelected.value || isSelected) && (!term || labelMatches) ? [item] : [];
    }
    let children = !term || labelMatches
      ? item.children
      : item.children.filter((child) => child.label.toLocaleLowerCase().includes(term));
    if (showOnlySelected.value) {
      children = children.filter((child) => selectedIds.value.includes(child.id));
    }
    return children.length ? [{ ...item, children }] : [];
  });
});

const selectedIds = computed<(string | number)[]>(() =>
  (props.modelValue ?? []).map((filter) => filter.Entity.Id),
);

function findOption(id: string | number): SelectOption | undefined {
  for (const item of items.value) {
    if (item.id === id) return item;
    if ('children' in item) {
      const child = item.children?.find((candidate) => candidate.id === id);
      if (child) return child;
    }
  }
  return undefined;
}

function updateSelected(ids: (string | number)[]) {
  const normalizedIds = props.singleMode && ids.length ? [ids[ids.length - 1]] : ids;
  const previous = new Map((props.modelValue ?? []).map((filter) => [filter.Entity.Id, filter]));
  const next = normalizedIds.flatMap((id) => {
    const numericId = Number(id);
    const existing = previous.get(numericId);
    if (existing) return [existing];
    const option = findOption(id);
    if (!option || !Number.isFinite(numericId) || numericId < 0) return [];
    return [{ Entity: { Id: numericId, Name: option.label }, Roles: [], Positive: true }];
  });
  emit('update:modelValue', next);
}

function getGroupState(group: SelectGroup) {
  const childIds = group.children?.map((child) => child.id) ?? [];
  return {
    isSelected: childIds.length > 0 && childIds.every((id) => selectedIds.value.includes(id)),
    isDisabled: childIds.length === 0,
  };
}

function close() { emit('close'); }

onMounted(async () => {
  loading.value = true;
  try {
    source.value = await AccessApi.getWorkersAndAccessGroups();
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppInput, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: "Поиск",
          "show-search-button": "",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["modelValue"])
      ]),
      (!_ctx.singleMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AppCheckbox, {
                value: showOnlySelected.value,
                onOnInput: _cache[2] || (_cache[2] = ($event: any) => (showOnlySelected.value = !showOnlySelected.value)),
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["value"]),
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Показать выбранных", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "access-filter-dropdown__reset",
              disabled: selectedIds.value.length === 0,
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (updateSelected([])), ["stop"]))
            }, " Сбросить ", 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_q_spinner, {
            color: "primary",
            size: "28px"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(UserGroupDropdownContent, {
            items: filteredItems.value,
            selected: selectedIds.value,
            "get-group-state": getGroupState,
            "update-selected": updateSelected,
            search: search.value,
            "single-mode": _ctx.singleMode,
            "current-owner": _ctx.singleMode ? selectedIds.value[0] ?? null : null,
            close: _ctx.singleMode ? close : undefined
          }, null, 8, ["items", "selected", "search", "single-mode", "current-owner", "close"])
        ]))
  ]))
}
}

})